import { Component, ErrorInfo, ReactNode } from 'react'
import { isChunkLoadError, reloadOnceForChunkError } from '../utils/gate'

interface State {
  chunkError: boolean
  otherError: unknown
}

/**
 * Ленивый экран не загрузился (после выкладки у файлов новые имена, а вкладка просит старые). Один раз
 * перезагружаем страницу, чтобы получить свежий index.html; если и это не помогло, говорим об этом прямо,
 * вместо белого экрана. Любые другие ошибки пробрасываются выше без изменений.
 */
export default class ChunkErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { chunkError: false, otherError: null }

  static getDerivedStateFromError(error: unknown): State {
    return isChunkLoadError(error) ? { chunkError: true, otherError: null } : { chunkError: false, otherError: error }
  }

  componentDidCatch(error: unknown, _info: ErrorInfo): void {
    if (isChunkLoadError(error)) reloadOnceForChunkError()
  }

  render() {
    if (this.state.otherError) throw this.state.otherError
    if (!this.state.chunkError) return this.props.children
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 dark:bg-gray-900">
        <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 text-center dark:border-gray-700 dark:bg-gray-800">
          <h1 className="mb-2 text-lg font-semibold text-gray-900 dark:text-white">Приложение обновилось</h1>
          <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">Нужно обновить страницу, чтобы загрузить новую версию.</p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>Обновить страницу</button>
        </div>
      </div>
    )
  }
}
